module.exports = __webpack_public_path__ + "static/media/ic_gauge.85029106.svg";